<footer class="container-fluid bg-black py-5">
  <div class="container">
    <div class="row text-white justify-content-center text-center text-md-start">
      <div class="col-12 col-sm-10 col-md-4 mb-4">
        <div class="footer-logo mb-2 text-center text-md-start">
          <img src="assets/img/white-logo.svg" alt="Wemble Logo" class="img-fluid" />
        </div>
        <p class="mb-1 footer-phone">{{ whatsappNumber }}</p>
        <p>{{ email }}</p>
        <div class="d-flex justify-content-center justify-content-md-start gap-3 mt-2">
          <a [href]="facebookUrl" target="_blank" rel="noopener noreferrer"><i
              class="bi bi-facebook fs-5 text-white"></i></a>
          <a [href]="xUrl" target="_blank" rel="noopener noreferrer"><i class="bi bi-twitter-x fs-5 text-white"></i></a>
          <a [href]="instaUrl" target="_blank" rel="noopener noreferrer"><i
              class="bi bi-instagram fs-5 text-white"></i></a>
          <a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer"><i
              class="bi bi-whatsapp fs-5 text-white"></i></a>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 mb-4">
        <div class="footer-title">{{ 'FOOTER.INFORMATION' | translate }}</div>
        <ul class="list-unstyled">
          <li><a routerLink="/about" class="text-decoration-none d-block mb-2">{{ 'FOOTER.ABOUT_US' | translate }}</a>
          </li>
          <li><a routerLink="/t&c" class="text-decoration-none d-block mb-2">{{ 'FOOTER.TERMS' | translate }}</a></li>
          <li><a routerLink="/privacy" class="text-decoration-none d-block">{{ 'FOOTER.PRIVACY' | translate }}</a></li>
        </ul>
      </div>

      <div class="col-12 col-sm-10 col-md-5 mb-4">
        <div class="footer-title">{{ 'FOOTER.NEWSLETTER' | translate }}</div>
        <p class="small">{{ 'FOOTER.NEWSLETTER_TEXT' | translate }}</p>
        <div class="newsletter d-flex flex-column flex-sm-row gap-2">
          <input type="email" [placeholder]="'FOOTER.EMAIL_PLACEHOLDER' | translate" class="form-control" />
          <button type="submit" class="btn newsletter-btn">{{ 'FOOTER.SUBSCRIBE' | translate }}</button>
        </div>
      </div>
    </div>
    <div class="footer-bottom text-white text-center mt-4 small">
      {{ 'FOOTER.COPYRIGHT' | translate }}
    </div>
  </div>
</footer>